// src/pages/Terminos.jsx
import React from "react";

const Shipment = () => {
  return (
    <div className="terminos-container">
      <iframe
        src="/assets/archivos/MANUAL DE USUARIO - CREACION DE INSTRUCCION DE EMBARQUE.pdf"
        title="Manual de Pre-Instrucción"
        className="pdf-viewer"
        frameBorder="0"
      ></iframe>
    </div>
  );
};

export default Shipment;
